import { Controller } from "@hotwired/stimulus"

function extractHostname(url) {
  try {
    return new URL(url).hostname.replace(/^www\./, "").toLowerCase()
  } catch {
    return url.replace(/^(https?:\/\/)?(www\.)?/i, "").split("/")[0].toLowerCase()
  }
}

export default class extends Controller {
  static targets = ["input", "modal", "modalIcon", "modalTitle", "modalBody"]
  static values = { messages: Array }

  inputTargetConnected() {
    this.inputTarget.addEventListener("input", () => this.inputTarget.setCustomValidity(""))
  }

  normalize(event) {
    let val = this.inputTarget.value.trim()
    if (val && !val.match(/^https?:\/\//i)) {
      val = `https://${val}`
      this.inputTarget.value = val
    }

    const host = extractHostname(val)

    if (!host || !host.includes(".")) {
      event.preventDefault()
      this.inputTarget.setCustomValidity("Please enter a valid domain (e.g. example.com)")
      this.inputTarget.reportValidity()
      return
    }

    this.inputTarget.setCustomValidity("")

    if (host === "readyforai.dev" && this.messagesValue.length > 0) {
      event.preventDefault()
      this.showSelfCheckModal()
    }
  }

  showSelfCheckModal() {
    const messages = this.messagesValue
    const msg = messages[Math.floor(Math.random() * messages.length)]
    this.modalIconTarget.textContent = msg.icon
    this.modalTitleTarget.textContent = msg.title
    this.modalBodyTarget.textContent = msg.body
    this.modalTarget.classList.remove("hidden")
    this.modalTarget.offsetHeight
    this.modalTarget.querySelector("[data-panel]").classList.add("scale-100", "opacity-100")
  }

  closeSelfCheckModal() {
    const panel = this.modalTarget.querySelector("[data-panel]")
    panel.classList.remove("scale-100", "opacity-100")
    setTimeout(() => this.modalTarget.classList.add("hidden"), 200)
  }
}
